"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelCall = exports.startCall = void 0;
const abortable_fetch_1 = require("../../../utils/abortable-fetch");
function startCall(url, id) {
    return abortable_fetch_1.abortableFetch(`${url}/${id}/start`, {
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        method: 'POST',
    });
}
exports.startCall = startCall;
function cancelCall(url, id) {
    return abortable_fetch_1.abortableFetch(`${url}/${id}/cancel`, {
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        method: 'POST',
    });
}
exports.cancelCall = cancelCall;
//# sourceMappingURL=jobs-api.js.map